import React from 'react';

import { useIntl } from 'react-intl';

import AkFlag from '@atlaskit/flag/flag';
import type { FlagProps } from '@atlaskit/flag/types';
import ErrorIcon from '@atlaskit/icon/core/status-error';
import Link from '@atlaskit/link/link';
import { token } from '@atlaskit/tokens';

import { getProductDisplayName, type Product } from '../../common/ui/products';
import { withLocalIntl } from '../../common/utils/i18n/intl-provider';
import { messages } from './messages';

export type Props = {
	flagComponent?: React.ElementType;
	id: FlagProps['id'];
	onDismiss: FlagProps['onDismissed'];
	targetProduct: Product;
};

const SUPPORT_LINK = 'https://support.atlassian.com/contact/';

export const RequestAccessErrorFlag: (props: Props) => React.JSX.Element = withLocalIntl(
	({ onDismiss, targetProduct, flagComponent: FlagComponent = AkFlag, ...props }: Props) => {
		const { formatMessage } = useIntl();

		return (
			<FlagComponent
				{...props}
				icon={<ErrorIcon spacing="spacious" label="Error" color={token('color.icon.danger')} />}
				onDismissed={onDismiss}
				title={formatMessage(messages.title, { product: getProductDisplayName(targetProduct) })}
				description={formatMessage(messages.description, {
					a: (chunks: (string | React.ReactNode)[]) => <Link href={SUPPORT_LINK}>{chunks}</Link>,
				})}
			/>
		);
	},
);
